import { type ProductKeys, ProductKeys as ProductKeysObject } from '../constants/product-keys';

/**
 * Filters out Atlas and AtlassianWebCrawler from products when nouns are shown,
 * since those become noun options instead.
 */
export function filterProductsForNouns(
	availableProducts: ProductKeys[],
	shouldShowNouns: boolean,
): ProductKeys[] {
	if (!shouldShowNouns) {
		return availableProducts;
	}
	return availableProducts.filter(
		(key) => key !== ProductKeysObject.Atlas && key !== ProductKeysObject.AtlassianWebCrawler,
	);
}
